import { useEffect } from 'react'
import UserManager from '../../services/UserManager'
import SuccessDialog from '../SuccessDialog/SuccessDialog'
import { SCREENS, analytics } from '../../services/Analytics/Analytics'
import { useTranslation } from 'react-i18next'

type PostPurchaseSuccessProps = {
  show: boolean
  onDismiss: () => void
} & ({ altText: string } | { htmlText: string })

export default function PostPurchaseSuccess(props: PostPurchaseSuccessProps) {
  const { show, onDismiss } = props
  const { t } = useTranslation()
  const userEmail = UserManager.getUserEmail()

  const TEXTS = {
    TITLE: t('order.done.woohoo'),
    CONTENT: t('order.done.will_receive_email'),
    DONE: t('general.done'),
    TALK: t('general.talk_to_us'),
  }

  useEffect(() => {
    if (show) {
      analytics.trackScreenView(SCREENS.POST_PURCHASE_SUCCESS)
    }
  }, [show])

  let text
  if ('htmlText' in props) {
    // eslint-disable-next-line react/no-danger
    text = <div dangerouslySetInnerHTML={{ __html: props.htmlText }} />
  } else if (userEmail) {
    text = (
      <span>
        {TEXTS.CONTENT} <b>{userEmail}</b>
      </span>
    )
  } else {
    text = <span>{props.altText}</span>
  }

  return (
    <>
      <SuccessDialog
        show={show}
        onDismiss={onDismiss}
        title={TEXTS.TITLE}
        text={text}
        noBackground
      />
    </>
  )
}
